module.exports = __webpack_public_path__ + "img/shopping-tag.a314e6ce.svg";